import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function NinthCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Cobiçar a Mulher do Próximo"}/>

            <p className="info-text">
            Este mandamento chama à pureza do coração. O CIC apresenta a concupiscência como impulso desordenado que nasceu do pecado original[67]. <br/>
            Todos enfrentam luta interior entre espírito e carne[96]. <br/>
            Por isso, exige-se purificar o coração: Dominar as paixões sensuais (virtude da castidade), evitar fantasias eróticas e colocar a razão e a vontade em sintonia com Deus[97][70]. <br/>
            A Bem-aventurança do puro de coração (Mt 5,8) é citada: aqueles que conquistam essa pureza verão a Deus e tratarão o corpo humano com reverência[70]. <br/>
            O mandamento não condena o amor ou a beleza, mas combate a luxúria (desejo desordenado). <br/> 
            Portanto, proíbe não só o adultério físico, mas também os pensamentos e desejos lascivos[64][95].
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
            Na prática, significa educar a vontade e os sentidos. Isso inclui observar moderação no olhar e no falar: evitar olhares libidinosos, roupas inapropriadas, conversas ou piadas vulgares. <br/>
            Praticar o autocontrole (continência) e buscar a castidade conforme o estado de vida (celebrações litúrgicas como matrimônio, ordenação, vidas consagradas)[64][68]. <br/>
            Auxiliam o cumprimento a leitura de bons livros, recitar orações ao sentir tentações (cf. CORINTO 5: tipo de oração citada em CIC 2520), jejum e participação nos sacramentos (eucaristia e confissão) para receber graça de Deus[98]. <br/>
            O mandamento também influencia a criação de leis e costumes: condenar a pornografia, a exploração sexual e não deturpar o significado do matrimônio. <br/>
            Pais e educadores devem transmitir aos jovens valores de respeito e dignidade sexual. <br/>
            Nos relacionamentos heterossexuais dentro do casamento, respeitar a plena entrega mútuo e a procriação é culto à vocação divina.
            </p> 

            <Title text={"Aspectos Teológicos"}/>
            <p className="info-text">
            Este mandamento ensina a ver a sexualidade como dom sagrado, ligado ao próprio designo de Deus[62]. <br/>
            Implica que o desejo sexual ordena-se ao amor fiel e à vida, sob a forma da caridade erótica proposta por São Paulo e presentes na doutrina católica. <br/>
            A castidade é uma virtude espiritual e graça de Deus[65]. Lutá-la é um combate espiritual. <br/>
            O Catecismo lembra que o pecado da carne está associado ao diabo e à insígnia do orgulho[99][100]. <br/>
            A pureza é vista como preparação para o céu (ver Deus): “Bem-aventurados os puros de coração, porque verão a Deus”[70]. <br/>
            É notável que para cada estado (celibato, castidade conjugal, vida familiar) há uma forma própria de viver a castidade como virtude. <br/>
            Em última análise, dominar a concupiscência é possível pela graça batismal e pelo Espírito Santo[101][100], que nos faz experenciar a modéstia e a sobriedade do olhar. 
            </p> 

            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}